// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"1ab9c361","755":"eb5f3310"}[chunkId] + ".chunk.js";
};